/* Hang Dry — shared cart helpers + product card quick-add / size picker behaviour.
   Loaded by hd-collection.liquid and hd-product.liquid. Safe to include twice. */
(function () {
  if (window.__hdColCardInit) return;
  window.__hdColCardInit = true;

  function refreshCartFallback() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-item-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) { b.style.display = cart.item_count > 0 ? '' : 'none'; });
        var cartBtn = document.querySelector('[data-cart-icon-bubble], .header__icon--cart');
        if (cartBtn) cartBtn.click();
      });
  }

  // Adds one unit of a variant, then re-renders and opens the Dawn cart drawer.
  function add(variantId) {
    var cartDrawer = document.querySelector('cart-drawer');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: cartDrawer ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }) : undefined,
        sections_url: window.location.pathname
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart/add failed');
      return r.json();
    })
    .then(function (response) {
      if (cartDrawer && response.sections) {
        cartDrawer.renderContents(response);
        cartDrawer.classList.remove('is-empty');
        return response;
      }
      return refreshCartFallback().then(function () { return response; });
    });
  }

  // Adds one unit, then goes straight to checkout.
  function buyNow(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart/add failed');
      window.location.href = '/checkout';
    });
  }

  // Wraps a button in a loading → "Added ✓" → restored cycle around add().
  function addWithButton(btn, variantId) {
    var orig = btn.innerHTML;
    btn.textContent = '...';
    btn.disabled = true;
    return add(variantId)
      .then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2200);
      })
      .catch(function () { btn.innerHTML = orig; btn.disabled = false; });
  }

  window.HDCart = { add: add, buyNow: buyNow, addWithButton: addWithButton };

  function init() {
    // Quick-add: single-variant products (and size-picked variants once a size is chosen)
    document.querySelectorAll('.hd-col__btn--add[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.dataset.variantId) return;
        addWithButton(this, this.dataset.variantId);
      });
    });

    // Inline size picker: pick a size, then swap the placeholder for the real Add to Bag / Buy Now pair
    document.querySelectorAll('.hd-col__sizegrid').forEach(function (grid) {
      var actions = grid.nextElementSibling;
      if (!actions) return;
      var needBtn = actions.querySelector('.hd-col__btn--needsize');
      var addBtn = actions.querySelector('.hd-col__btn--sizeadd');
      var buyBtn = actions.querySelector('.hd-col__btn--sizebuy');
      grid.querySelectorAll('.hd-col__sizebtn:not(.hd-col__sizebtn--soldout)').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          grid.querySelectorAll('.hd-col__sizebtn').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          var variantId = btn.dataset.variantId;
          if (addBtn) { addBtn.dataset.variantId = variantId; addBtn.hidden = false; }
          if (buyBtn) { buyBtn.dataset.variantId = variantId; buyBtn.hidden = false; }
          if (needBtn) needBtn.hidden = true;
        });
      });
    });

    // "View" / placeholder buttons navigate to the product page
    document.querySelectorAll('.hd-col__btn--view, .hd-col__btn--add:not([data-variant-id]):not(.hd-col__btn--needsize)').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var target = this.closest('[data-product-url]');
        if (target) window.location.href = target.getAttribute('data-product-url');
      });
    });

    // Buy Now: add to cart, then skip the drawer and go straight to checkout
    document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var el = this;
        if (!el.dataset.variantId) return;
        el.disabled = true;
        el.textContent = '...';
        buyNow(el.dataset.variantId).catch(function () { el.disabled = false; el.textContent = 'Buy Now'; });
      });
    });

    // Quick-add popover: open/close, closing any other open ones first
    function closeAll(except) {
      document.querySelectorAll('.hd-col__quickadd').forEach(function (p) {
        if (p !== except) p.hidden = true;
      });
    }
    document.querySelectorAll('.hd-col__quickadd-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var popover = this.parentElement.querySelector('.hd-col__quickadd');
        if (!popover) return;
        var willOpen = popover.hidden;
        closeAll(willOpen ? popover : null);
        popover.hidden = !willOpen;
      });
    });
    document.querySelectorAll('.hd-col__quickadd-close').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var popover = this.closest('.hd-col__quickadd');
        if (popover) popover.hidden = true;
      });
    });
    document.querySelectorAll('.hd-col__quickadd').forEach(function (popover) {
      popover.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    document.addEventListener('click', function () { closeAll(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
